import mime from 'mime';
import axios from 'axios'
import api, { API_URL } from './api';

export const uploadFileAndStartImport = async (projectId, file, eventSourceRef, onProgress, onDone, onError) => {
  const mimeType = mime.getType(file.name);
  const fileTypes = [{ mimeType }];

  const {
    data: { urls }
  } = await api.post('/generate-presigned-urls', {
    files: fileTypes,
  });

  await axios.put(urls[0].uploadUrl, file, {
    headers: { 'Content-Type': mimeType }
  });

  const fileUrl = urls[0].cloudfrontUrl;
  const es = new EventSource(`${API_URL}/import-stores?csvUrl=${encodeURIComponent(fileUrl)}&projectId=${projectId}`);
  eventSourceRef.current = es;

  es.onmessage = (event) => {
    const data = JSON.parse(event.data);

    if (data.error) {
      es.close();
      onError(data.error);
      return;
    }

    onProgress(data);

    if (data.done) {
      es.close();
      onDone(data);
    }
  };

  es.onerror = () => {
    es.close();
    onError('Connection error.');
  };
};